import React from "react";
import "./Button.css";

export default function EmailButton({ title, email, subject, body }) {
    const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    return (
        <a href={mailtoLink} style={{ textDecoration: "none" }}>
            <button className="Button-Style">
                {title}
            </button>
        </a>
    );
}
